import {
  passwordPolicyDisplayRules,
  requiresServerValidation
} from 'js/lib/password-policy'
import template from './index.pug'

export default {
  name: 'password-policy-modal',
  template: template(),
  props: {
    policy: {
      type: Object,
      required: true
    }
  },
  computed: {
    rules() {
      return passwordPolicyDisplayRules(this.policy)
    },
    requiresServerValidation() {
      return requiresServerValidation(this.policy)
    }
  },
  methods: {
    ruleText(rule) {
      return typeof rule.value === 'number' ?
        this.$tc(rule.key, rule.value, {count: rule.value}) :
        this.$t(rule.key)
    }
  }
}
